import Logout from 'components/Logout';
import { EventInvite } from 'pages/EventInvite';
import { ForgotPassword } from 'pages/ForgotPassword';
import { Login } from 'pages/Login';
import { Register } from 'pages/Register';
import { RegisterIframe } from 'pages/RegisterIframe';

interface IPublicRoute {
  documentId: string;
  component: React.ReactNode;
  path: string;
  isPublic: boolean;
}

export const PublicRoutes: IPublicRoute[] = [
  {
    documentId: 'login',
    component: <Login />,
    path: '/login',
    isPublic: true,
  },
  {
    documentId: 'register',
    component: <Register />,
    path: '/register',
    isPublic: true,
  },
  {
    documentId: 'register-iframe',
    component: <RegisterIframe />,
    path: '/register-iframe',
    isPublic: true,
  },
  {
    documentId: 'forgot-password',
    component: <ForgotPassword />,
    path: '/forgot-password',
    isPublic: true,
  },
  {
    documentId: 'event-invite',
    component: <EventInvite />,
    path: '/invite/event/:invite_uuid',
    isPublic: true,
  },
  { documentId: 'logout', component: <Logout />, path: '/logout', isPublic: true },
];

export const isPublicRoute = (path: string): boolean => {
  // First try to match static exact paths
  if (PublicRoutes.some(route => route.path === path && route.isPublic)) {
    return true;
  }

  // Then test for dynamic params using a simple path-to-regexp approach
  for (const route of PublicRoutes) {
    if (!route.isPublic) continue;

    // Escape regex special chars EXCEPT for ":" (needed for param matching)
    const pattern = route.path
      .replace(/([.+?^=!${}()|[\]/\\])/g, '\\$1') // Removed : from escape pattern
      .replace(/:([^/]+)/g, '[^/]+'); // Replace :param with a dynamic part

    const regex = new RegExp(`^${pattern}$`);
    if (regex.test(path)) {
      return true;
    }
  }

  return false;
};
